import { Box, Flex } from '@chakra-ui/react';
import { checkNewNavEnabled } from 'utils/helpers/featureFlags';

import { MeshMavenWithOrangeBulb } from 'assets/assetsV1/iconComponents/MeshMavenWithOrangeBulb';

import { SkeletonLoader } from 'uiToolkitV1/SkeletonLoader';
import { TextBodyMedium } from 'uiToolkitV1/Typography';

import { ColdStartMeshRecommends } from './ColdStartMeshRecommends';
import { NudgeCardWrapper } from './NudgeCardWrapper';
import { useGetNudgeCardsQuery } from './dataHooks';
import { mapNudgeDataToProps } from './helpers/mapNudgeDataToProps';

export const MeshRecommends = () => {
  const {
    data: rawNudgeCards,
    isLoading,
    isError,
  } = useGetNudgeCardsQuery({
    pageType: 'HOME_PAGE',
  });

  if (isError) {
    return null;
  }

  if (isLoading) {
    return (
      <Box
        bg={checkNewNavEnabled() ? 'rgba(13, 129, 159, 0.10)' : 'surface.F5F7F9'}
        p={4}
        borderRadius="8px"
        mb={checkNewNavEnabled() ? 0 : 6}
      >
        <SkeletonLoader />
      </Box>
    );
  }

  const nudgeCards = mapNudgeDataToProps(rawNudgeCards ?? []);

  return (
    <Box
      bg={checkNewNavEnabled() ? 'rgba(13, 129, 159, 0.10)' : 'surface.F5F7F9'}
      px={4}
      pb={4}
      pt={2}
      borderRadius="8px"
      mb={checkNewNavEnabled() ? 0 : 6}
    >
      <Flex direction="column" gap={2}>
        <Flex align="center" mx={1}>
          <Flex gap={2} alignItems="center">
            <MeshMavenWithOrangeBulb boxSize="56px" />
            <TextBodyMedium bold mt="3px">
              Maven Recommends
            </TextBodyMedium>
          </Flex>
        </Flex>
        <Flex
          direction="column"
          gap={2}
          // @todo: remove this once rabbit package is updated
          sx={{
            '& img': {
              objectFit: 'cover',
            },
          }}
        >
          {!nudgeCards?.length && <ColdStartMeshRecommends />}
          {!!nudgeCards?.length && <NudgeCardWrapper nudgeCards={nudgeCards} />}
        </Flex>
      </Flex>
    </Box>
  );
};
